var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_ClaimRecord_form_dialog_viewClaimItemTitle"),
      dialog: _vm.show,
      width: "700",
      maxWidth: "700",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Taber", {
              attrs: {
                curTab: _vm.curTab,
                backgroundColor: "white",
                items: _vm.taber,
              },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form1", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      value: _vm.$getCommonLangValue(
                                        _vm.Data.claim_item_type_name
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_claimItemTypeLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      value: _vm.$getCommonLangValue(
                                        _vm.Data.claim_item_name
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_claimItemNameLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      value: _vm.$getDateTime(
                                        _vm.Data.payout_utc_datetime,
                                        "YYYY/MM/DD"
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_consumptionDateLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      value: _vm.$getCommonLangValue(
                                        _vm.Data.claim_reason_name
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_claimReasonLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      value: _vm.$getCommonLangValue(
                                        _vm.Data.claim_item_description
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_descriptionLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form2", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_ClaimRecord_form_dialog_attachmentLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("ImgDragUpdate", {
                                    attrs: {
                                      defaultImageList: _vm.Data.attachments,
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      value: _vm.Data.receipt_swift_number,
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_swiftNumberLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      value: _vm.$getCommonLangValue(
                                        _vm.Data.cost_center_name
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_costCentreLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form3", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      prefix: _vm.Data.actual_currency_code,
                                      suffix: parseFloat(
                                        Number(_vm.Data.actual_amount)
                                      ).toString(),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_actualAmountLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      prefix: _vm.Data.claim_currency_code,
                                      suffix: parseFloat(
                                        Number(_vm.Data.claim_amount)
                                      ).toString(),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_claimAmountLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: false,
                                      readonly: true,
                                      prefix: _vm.Data.approved_currency_code,
                                      suffix: parseFloat(
                                        Number(_vm.Data.approved_amount)
                                      ).toString(),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_approvalAmountLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }